var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBakery2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "q9dnrjpsea",
    d: "M0 0.43L19.765 0.43 19.765 22.759 0 22.759z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .47)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "eeto09yuqb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q9dnrjpsea"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#70C494",
    d: "M12.377.43C8.297.43 4.99 3.763 4.99 7.873v1.525l-.036-.048c-.933-1.216-2.67-1.441-3.878-.5-1.209.94-1.432 2.688-.499 3.906l4.413 5.756v4.247h14.776V7.873c0-4.11-3.308-7.443-7.388-7.443",
    mask: "url(#eeto09yuqb)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4A8254",
    d: "M6.423 25.67L18.395 25.67 18.395 23.229 6.423 23.229z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBakery2);
export default __webpack_public_path__ + "static/media/bakery2.5858ab2419c091370d3c04622943e2b1.svg";
export { ForwardRef as ReactComponent };